import { BasketProvider, isReady } from './BasketProvider';

export { isReady };

void new BasketProvider();
